module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_9.c68d22cf.jpg";